import { updateModuleCardsinEditor, getVeevaLinkedModulesListByid } from "../../services/apis";
import { normalizeModuleContentKey } from "./claimEditorUsage";

export const mustUseRemove = ({editor, appData}) => {
  const MATCH_ATTRIBUTES = new Set(["matchText", "matchTextVariant"]);

  const updateUsedState = (data, id, action) => {
    const clicked = data.find((item) => item.id === id);
    if (!clicked) return data;

    const targetElementId = clicked.elementId;
    const targetNorm = normalizeModuleContentKey(clicked.content);

    return data.map((item) => {
      let shouldBeUsed = item.used;

      if (item.id === id) {
        shouldBeUsed = action === "add" ? true : false;
      }

      if (
        MATCH_ATTRIBUTES.has(clicked.attribute) &&
        item.moduleId === clicked.moduleId &&
        item.elementId === targetElementId &&
        MATCH_ATTRIBUTES.has(item.attribute)
      ) {
        shouldBeUsed = action === "add" ? true : false;
      }

      if (
        targetNorm &&
        item.moduleId === clicked.moduleId &&
        normalizeModuleContentKey(item.content) === targetNorm
      ) {
        const clickedMatch = MATCH_ATTRIBUTES.has(clicked.attribute);
        const itemMatch = MATCH_ATTRIBUTES.has(item.attribute);
        if (clickedMatch && itemMatch && item.elementId !== targetElementId) {
          /* two different slices, same coincidental match copy */
        } else {
          shouldBeUsed = action === "add" ? true : false;
        }
      }

      return { ...item, used: shouldBeUsed };
    });
  };

  function getDeckModules(deckId) {
    return new Promise((resolve, reject) => {
      getVeevaLinkedModulesListByid(deckId, (response, err) => {
        if (err) {
          reject(err);
        } else {
          resolve(response?.data?.response?.selected_module_data || []);
        }
      });
    });
  }

  let deckLevelContent = [];

  async function loadDeckModules() {
    try {
      deckLevelContent = await getDeckModules(appData.deckId._id);
      console.log("Global data:", deckLevelContent);
    } catch (error) {
      console.error(error);
    }
  }

  function updateDBDeckContent(deckId, payload) {
    const payloadInput = {
      selected_module_data: payload,
    };
    return new Promise((resolve, reject) => {
      updateModuleCardsinEditor(deckId, payloadInput, (response, err) => {
        if (err) {
          reject(err);
        } else {
          resolve(response?.data?.response?.selected_module_data || []);
        }
      });
    });
  }

  async function updateDeckContent(updateData) {
    try {
      await updateDBDeckContent(appData.deckId._id, updateData);
    } catch (error) {
      console.error(error);
    }
  }

  async function initializeDeck() {
    if (!appData?.deckId?._id) {
      console.warn("Deck ID not available");
      return null;
    }

    try {
      const modules = await getDeckModules(appData.deckId._id);

      if (!modules) {
        console.warn("No metadata found for this deck");
        return null;
      }

      appData.setDeckId((prev) => ({
        ...prev,
        selected_module_data: modules,
      }));

      return modules;
    } catch (err) {
      console.error("Failed to load deck metadata", err);
      return null;
    }
  }

  async function setupEditor() {
    // Step 1: Load metadata first
    const modules = await initializeDeck();

    // console.log("Metadata loaded:", modules);

    // Step 2: Bind editor events AFTER loading
    bindEditorEvents();
  }

  function bindEditorEvents() {
      editor.on("component:remove", (component) => {
          if (!editor.getSelected()) return;
      const id = component.getAttributes()["data-content-id"];
          if (!id) return;
          console.log("removed on load must use file", id)
          
      appData.setDeckId((prev) => {
        if (!prev?.selected_module_data) return prev;

        const updatedModules = updateUsedState(
          prev.selected_module_data,
          id,
          "remove",
          );
          
          updatedModules.forEach(item => {
              let text = '';
              if (component.getAttributes()['src']) {
                  text = component.getAttributes()['src']
              } else {
                               text = component.get('components').models.map(m => m.get('content')).join('');

              }
           if (
          item.content === text 
        ) {
          console.log("Before:", item.count);
           item.count = Math.max(0, item.count - 1);
          console.log("After:", item.count);
        }
        });

        if (prev?._id) {
          updateDBDeckContent(prev._id, updatedModules);
        }

        return {
          ...prev,
          selected_module_data: updatedModules,
        };
      });
    });
    }
    setupEditor();
};
